import React from 'react';
import { match, Redirect, useLocation } from 'react-router-dom';
import { endOfDay, isAfter, parse } from '@qover/utils/src/date';
import { RedirectUrlMissingQueryParam } from '@qover/molecules';
import { TripType } from '@qover-private/protos-web/qover/dojo/travel/v1/terms';
import { useFieldValue } from '@qover/hooks';

type RedirectionProps = {
  match: match;
};

export const TripDurationRedirection: React.FC<RedirectionProps> = props => (
  <RedirectUrlMissingQueryParam
    to={`${props.match.path}/trip-duration`}
    param="id"
  >
    {props.children}
  </RedirectUrlMissingQueryParam>
);

export const NeedsRedirection: React.FC<RedirectionProps> = props => (
  <RedirectUrlMissingQueryParam to={`${props.match.path}/needs`} param="id">
    {props.children}
  </RedirectUrlMissingQueryParam>
);

export const QuoteRedirection: React.FC<RedirectionProps> = props => (
  <RedirectUrlMissingQueryParam to={`${props.match.path}/quote`} param="id">
    {props.children}
  </RedirectUrlMissingQueryParam>
);

export const LandingRedirection: React.FC<RedirectionProps> = props => (
  <RedirectUrlMissingQueryParam to={props.match.path} param="id">
    {props.children}
  </RedirectUrlMissingQueryParam>
);

// @ts-ignore
export const TripRedirection: React.FC<RedirectionProps> = props => {
  const location = useLocation();
  const startDateValue = useFieldValue<string>('startDate');
  const tripTypeField = useFieldValue<TripType>('terms.tripType');

  if (
    tripTypeField === TripType.TRIP_TYPE_SINGLE_TRIP &&
    (!startDateValue || isAfter(endOfDay(), startDateValue))
  ) {
    return (
      <Redirect
        to={`${props.match.path}/trip-duration/error-start-date-past${location.search}`}
      />
    );
  }

  return props.children;
};
